export const LARGE_CONTAINER_SIZE = 1920;
export const defaultLayoutConfig = {
    rowSizeDesktop: 270,
    rowSizeMobile: 250,
    rowSizeMobileLarge: 250,
    rowSizeCardDesktop: 360,
    rowSizeCardMobile: 250,
    itemSpacingDesktop: 8,
    itemSpacingMobile: 8,
    itemSpacingCardDesktop: 16,
    itemSpacingCardMobile: 8,
    galleryGutter: false
};

//# sourceMappingURL=constants.js.map